// extracted by mini-css-extract-plugin
export default {"root":"s54Ej","button":"k0HC1","active":"zMual","text":"pBvWr"};